import {
  Flower2,
  Leaf,
  Mountain,
  Palmtree,
  Shrub,
  Sprout,
  TreeDeciduous,
  TreePine,
  Waves,
} from 'lucide-react';
import { GARDEN_NATURAL_ELEMENTS } from '../lib/gardenDesignOptions';

/** @type {Record<string, typeof Flower2>} */
const ELEMENT_ICONS = {
  Flower: Flower2,
  'Ground Cover': Leaf,
  'Fruit Tree': TreeDeciduous,
  'Climbers Plant': Sprout,
  'Flowering Tree': TreePine,
  'Undulating Terrain': Mountain,
  Hedge: Shrub,
  'Ornamental Grass': Leaf,
  Lawn: Sprout,
  'Flowering Shrub': Flower2,
  'Shade Tree': TreeDeciduous,
  'Flower Bed': Flower2,
  Rock: Mountain,
  'Palm Tree': Palmtree,
  'Succulent Plants': Leaf,
  Bamboo: TreePine,
  'Small Bushes': Shrub,
  'Tall Trees': TreePine,
  'Water Plants': Waves,
};

/**
 * @typedef {{ id: string; label: string; Icon: typeof Flower2 }} GardenNaturalElement
 */

/** @type {GardenNaturalElement[]} */
export const GARDEN_NATURAL_ELEMENT_OPTIONS = GARDEN_NATURAL_ELEMENTS.map((label) => ({
  id: label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, ''),
  label,
  Icon: ELEMENT_ICONS[label] || Leaf,
}));
